import { apiFetch } from './client';

export interface AccountState {
  exists: boolean;
  deleted: boolean;
  deleted_at: string | null;
  purge_at: string | null;
  retention_days: number;
  data_categories: string[];
}

export const accountApi = {
  getState: () => apiFetch<AccountState>('/api/account/state'),
  deleteAccount: () =>
    apiFetch<AccountState & { ok: boolean }>('/api/account/delete', {
      method: 'POST',
      body: JSON.stringify({ confirm: true }),
    }),
  restore: () =>
    apiFetch<AccountState & { ok: boolean }>('/api/account/restore', {
      method: 'POST',
      body: JSON.stringify({}),
    }),
  reset: () =>
    apiFetch<AccountState & { ok: boolean }>('/api/account/reset', {
      method: 'POST',
      body: JSON.stringify({}),
    }),
};
